export const salesInvoiceConstants = {
  INVOICES_REQUEST: 'CONTRACTOR_INVOICES_REQUEST',
  INVOICES_SUCCESS: 'CONTRACTOR_INVOICES_SUCCESS',
  INVOICES_FAILURE: 'CONTRACTOR_INVOICES_FAILURE',
};
